import './EFormSection.scss';

type Props = {
  title: string;
  subtitle?: JSX.Element | string;
  button?: JSX.Element | JSX.Element[];
  rightPanel?: JSX.Element | JSX.Element[];
  leftPanel?: JSX.Element | JSX.Element[];
  children: JSX.Element | JSX.Element[];
  fullWidth?: boolean;
};

export function EFormSection({
  title,
  subtitle,
  button,
  rightPanel,
  leftPanel,
  children,
  fullWidth,
}: Props) {
  return (
    <div className={'form-section'}>
      <div className="form-section--left">
        <div className="form-section--left--content">
          <span className="font-semibold">{title}</span>
          <p className="mt-2 opacity-60 text-sm">{subtitle}</p>
          {button ? <div className="mt-8">{button}</div> : null}
          {leftPanel ? <div className='pt-7'> {leftPanel} </div> : <></>}

        </div>
      </div>
      {fullWidth ? (
        <div className="form-section--middle full-width">{children}</div>
      ) : (
        <>
          <div className="form-section--middle">{children}</div>
          <div className="form-section--right">{rightPanel}</div>
        </>
      )}
    </div>
  );
}

export default EFormSection;